import { Col, Container, ListGroup, ListGroupItem, Row } from "react-bootstrap";
import Image from 'react-bootstrap/Image';
import eme from '../resources/eme.svg';
import ame from '../resources/ame.png';
import grammarlabs from '../resources/grammarlabs.png'
import logo from '../resources/logo.jpg'
import { Helmet, HelmetProvider } from 'react-helmet-async';
export function Aboutus() {

    return (
        <>
            <Container>
                <HelmetProvider>
                    <Helmet>
                        <title>EnglishEditAI - About Us</title>
                        <meta name="description" content="EnglishEditAI was developed by Grammar Labs. Learn more about our portfolio of websites and services."></meta>
                    </Helmet>
                </HelmetProvider>
                <Row>
                    <Col></Col>
                    <Col style={{ textAlign: "center" }}>
                        <h1>About Us</h1>
                    </Col>
                    <Col></Col>
                </Row>
                <Row style={{ marginTop: "2em" }}>
                    <Col lg={2}></Col>
                    <Col lg={8}>
                        <p style={{ textAlign: "justify" }}>
                            <a style={{ textDecoration: 'underline', color: '#9bc97f', fontWeight: 600 }} href="http://grammarlabs.com">Grammar Labs</a>, the parent company of <span style={{ color: '#7B3A3A', fontWeight: 600 }}>ENGLISHEDIT.AI</span>, was founded in 2004. Over the years, we have built Grammar Labs into a leading provider of English editing services. To date, we have edited over 300 million words across our two services:
                            <a href="http://americanmanuscripteditors.com" style={{ textDecoration: 'underline', color: '#8396c0', fontWeight: 600 }}> American Manuscript Editors</a> and <a href="http://editmyenglish.com" style={{ textDecoration: 'underline', color: '#6AA843', fontWeight: 600 }}>EditMyEnglish</a>. For nearly two decades, our team of dedicated editors has assisted customers worldwide in achieving the highest level of writing.
                        </p>
                    </Col>
                    <Col></Col>
                </Row>
                <Row>
                    <Col lg={2}></Col>
                    <Col lg={8}>
                        <p style={{ textAlign: "justify" }}>
                            In gratitude for the unwavering support from our clientele over the years, we proudly present <span style={{ color: '#7B3A3A', fontWeight: 600 }}>ENGLISHEDIT.AI</span> - a free writing tool. Beyond just grammatical corrections, it offers insights to make text more readable and concise. With customization options, users can adjust the editing to fit their specific needs. Gone are the days of prolonged waits for edited content; with <span style={{ color: '#7B3A3A', fontWeight: 600 }}>ENGLISHEDIT.AI</span>, you receive near-instantaneous refined text.
                        </p>
                    </Col>
                    <Col></Col>
                </Row>
                <Row>
                    <Col lg={2}></Col>
                    <Col lg={8}>
                        <p style={{ textAlign: "justify" }}>
                            Our technology harnesses the power of the latest NLP models from <a href="http://openai.com" style={{ textDecoration: 'underline', color: '#181f14', fontWeight: 600 }}>OpenAI</a> to elevate and perfect English text. Every instance of text processed by our tool triggers billions of computations on sophisticated GPUs, ensuring an outcome that substantially enhances your writing. Give our tool a try today and let us know how it works for you.
                        </p>
                    </Col>
                    <Col></Col>
                </Row>
                <Row>
                    <Col lg={12} style={{ textAlign: 'center' }}>
                        <a href="http://grammarlabs.com"><Image src={grammarlabs} /></a>
                    </Col>
                </Row>

                <Row className="mt-5">
                    <Col lg={4} style={{ paddingLeft: '5em' }}>
                        <a href="http://americanmanuscripteditors.com"><Image src={ame} /></a>
                        <ul className="mt-4">
                            <li><span>PhD/Masters Level Technical Editors</span></li>
                            <li><span>Journal Manuscript Editing</span></li>
                            <li><span>Thesis/Dissertation Editing</span></li>
                            <li><span>8hr Turnaround Options</span></li>
                        </ul>
                    </Col>
                    <Col lg={4} style={{ paddingLeft: '10em' }} className="mt-4" >
                        <a href="http://editmyenglish.com"><Image src={eme} /></a>
                        <ul style={{ marginTop: '2em' }}>
                            <li><span>US Based Editors</span></li>
                            <li><span>Academic Editing</span></li>
                            <li><span>Business Editing</span></li>
                            <li><span>4hr Turnaround Options</span></li>
                        </ul>

                    </Col>
                    <Col lg={4} style={{ paddingLeft: '5em' }} className="mt-4">
                        <a href="http://englishedit.ai"><Image style={{ width: 100 + '%' }} src={logo} /></a>
                        <ul style={{ marginTop: '2em' }}>
                            <li><span>Free Editing and Writing Tool</span></li>
                            <li><span>Instant Results</span></li>
                            <li><span>Powered by Top AI Models from OpenAI</span></li>
                        </ul>
                    </Col>
                </Row>
                <br />
            </Container>
        </>
    )
}